<template>
	<div class="container">
		<!--页面开始-->
		<div class="main">
			<!--到顶部-->
			<go-top></go-top>
			<!--到顶部-->
			<div class="tit_one text_center">Privacy Policy</div>
			<!-- <div class="text_right font-weight pad-bot-10">Update Date:</div>
			<div class="text_right font-weight pad-bot-10">Effective Date:</div> -->
			<div class="text_right font-weight">Version: V0.1</div>
			
			<div class="txt_box pad-bot-15">
				Your privacy is very important to CORE GROUP (hereinafter referred to as "our company") because we are well aware of your trust in us, when you use the services provided by our company’s product, Test Helper (hereinafter referred to as "this product"). These privacy protection guidelines of our company (hereinafter referred to as "the guidelines") will inform you what information our company collects from visitors/users/customers and how we process this information to improve your experience. Please read it carefully.
			</div>
			
			
			<div class="txt_box pad-bot-15">
				This guide may be changed at any time without prior notice to any visitor/user/customer. Therefore, we strongly recommend that you visit this page of our company regularly to see if there are any changes to these terms. By using this product, you agree to and authorize the terms in this guide.
			</div>
			
			
			<div class="font-weight col-000 tit_two">Content</div>
			<div class="txt_box pad-bot-15">
				<ul class="tit-li">
					<li style="padding-top:0;">
						<div @click.stop.prevent="jumpDom('quesOne')">What is the purpose of collecting personal information?</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesTwo')">How does our company collect, use and disclose personal information?</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesThree')">Does our company share the collected information?</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesFour')">Do we use cookies or similar technologies?</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesFive')">Information security</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesSix')">Privacy</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesSeven')">Applicable laws</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesEight')">Amendments and changes</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesNight')">Other matters</div>
					</li>
					<li>
						<div @click.stop.prevent="jumpDom('quesTen')">Contact Us</div>
					</li>
				</ul>
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesOne">What is the purpose of collecting personal information?</div>
			<div class="txt_box">
				The information you provide to us will be used to reply, inquire, notify (if you have previously provided permission) or provide you with information about products and services requested.
			</div>
			<div class="txt_box">
				We use your information to specifically provide you with product content and product services.
			</div>
			<div class="txt_box pad-bot-15">
				We use your information to provide services for your account, including but not limited to investigating issues, resolving disputes, etc. Our company will not sell your information to third parties unless stated at the time of collection.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesTwo">How does our company collect, use and disclose personal information?</div>
			<div class="txt_box">
				1. In accordance with the provisions of the law, we will collect, use and disclose your personal information under specific circumstances. The following terms describe how we collect, use and disclose your personal information.
			</div>
			<div class="txt_box">
				2. Information collection
			</div>
			<div class="txt_box">
				<span style="font-weight:bold;">A. Provided By The User</span>
				<span style="display:inline-block;padding-top:0.15rem">
					We will save the information you provide directly. For example: We will record your registration and login information or other records of communication with us. The types of recorded information include: mobile phone number, email address, system album, location, and other information you choose to provide. We collect, use and disclose personal information to provide you with services by creating accounts, identifying users, responding to inquiries and emails, etc.
				</span>
			</div>
			<div class="txt_box">
				<span style="font-weight:bold;">B. Automatic Collection</span>
				<span style="display:inline-block;padding-top:0.15rem">
					When you contact or use our services, we will automatically collect your information including: Log information (we record all log information when you use the service, including device information, time of use, pages viewed, data results, IP address and source).
				</span>
			</div>
			<div class="txt_box">
				3. Use of information
				<ul>
					<li>Your personal information will not be used for other purposes unless it is stated in this privacy policy or the update of this privacy policy fails to notify you first.</li>
					<li>Anonymous aggregate statistical data is not user’s personal information defined by our company. We will store and use such information for a variety of purposes, including but not limited to analysis and usage pattern reports. This Privacy Policy does not limit in any way our use or disclosure of anonymous aggregate statistical data. Our company reserves the right to allow third parties to use and disclose anonymous aggregate statistical data for any purpose or unilaterally.</li>
					<li>
						The information you upload in this product may damage the legitimate rights and interests of you or others. You must be fully aware of the existence of such risks. You expressly agree to bear all risks and consequences of uploading information by yourself, and our company does not need to bear any responsibility.
						<span style="display:inline-block;padding-top:0.15rem">
							PUBLIC FORUMS：The product may include interactive forums such as message boards and chat rooms. Please remember that any information that is disclosed in these areas becomes public information and you should exercise caution when deciding to disclose your personal information.
						</span>
						<span style="display:inline-block;padding-top:0.15rem">
							THIRD PARTY WEBSITES: The product may contain links to other websites. This Policy does not apply to those websites.  If you choose to visit other websites, our company is not responsible for the privacy practices or content of those other websites, and it is your responsibility to review the privacy policies at those websites to confirm that you understand and agree with their policies.
						</span>
					</li>
				</ul>
			</div>
			<div class="txt_box">4. Statutory disclosure</div>
			<div class="txt_box pad-bot-15">
				Although we will do our best to protect user privacy, when we have reason to believe that only disclosure of personal information can comply with current judicial procedures, court orders or other legal procedures or protect the rights, property or safety of our company, our users, or third parties , we may disclose personal information.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesThree">Does our company share the collected information?</div>
			<div class="txt_box">
				We will not sell your personal information. However, we will share personal information with our suppliers, contractors and service partners or other third parties (collectively referred to as "service providers"). Service providers include analytics companies, advertisers, payment processing companies, customer service and support providers, email, IT service and SMS providers, web hosting and development companies, and fulfillment companies. Service providers also include co-promotion partners for products that we develop and/or sell jointly with other companies.
			</div>
			<div class="txt_box">
				Certain service providers may collect personal data on behalf of our company. These third parties may have access to personal data required to perform their functions. In addition, our company’s approach is to require its service providers to keep your personal information confidential and only use personal information to perform functions for our company.
			</div>
			<div class="txt_box pad-bot-15">
				Our company may also disclose your personal information to any competent law enforcement agency, regulatory or government agency, court or other third parties in accordance with legal requirements. If we believe that the disclosure is necessary to comply with regulatory requirements, judicial procedures, court orders, government requirements or provide us Or protect the safety, rights or property of our visitors/users/customers or others, as well as exercise, establish or defend the legal rights of our company.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesFour">Do we use cookies or similar technologies?</div>
			<div class="txt_box pad-bot-15">
				We will not use cookies in this product, but we use token technology only to save your login status.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesFive">Information Security</div>
			<div class="txt_box">
				1. Storage
				<ul>
					<li>Our company will ensure that the collection of your personal information is legally and effectively executed in accordance with laws and regulations and the provisions of the regulatory authorities, and will keep all the personal information of users confidential.</li>
					<li>Our company will only retain your personal information for the period necessary for the purposes described in the</li>
				</ul>
			</div>
			<div class="txt_box">
				2. Protection
			</div>
			<div class="txt_box">
				Our company promises to achieve a reasonable level of information security protection. In order to prevent the leakage, loss or damage of your information, our company will use the following but not limited to the following technical and management methods to protect the safety of your personal information:
				<ul>
					<li>Encrypted transmission of information;</li>
					<li>Encrypted storage of information;</li>
					<li>Strict access control in the data center;</li>
					<li>Establish an internal control management system and adopt the principle of minimum authorization for internal personnel who can access your personal information;</li>
					<li>To monitor the handling of your personal information by internal personnel;</li>
					<li>Training and assessment of national industry laws and regulations, privacy and security requirements, and information security awareness for internal personnel;</li>
					<li>Emergency response to information security incidents: Due to the emergence of various factors outside the controllable range or the continuous development of external malicious means, after a personal information security incident unfortunately occurs, our company will comply with the requirements of laws and regulations, including but not limited to mail, Letters, phone calls or push notifications will promptly inform you of the basic information of the information security incident, scope and impact, measures taken or about to be taken, remedial measures, self-prevention and risk reduction recommendations, etc., when it is difficult to inform the personal information subjects one by one due to special circumstances, Our company will adopt a reasonable and effective way to make announcements. At the same time, our company will proactively report the progress and status of handling information security incidents to higher-level supervisory units in a timely manner.</li>
				</ul>
			</div>
			<div class="txt_box">
				3. If our company ceases operations, our company will immediately stop collecting your personal information, delete or anonymize all stored personal information.The news will be posted on this page after the update.
			</div>
			<div class="txt_box">4. Privacy protection of minors</div>
			<div class="txt_box">
				Our company attaches great importance to the protection of personal privacy information of minors. This product can be used by children. If you are under 18 years old, you can only use it with the participation of a parent or guardian (hereinafter referred to as the "guardian"). This product will establish and maintain reasonable procedures to ensure the confidentiality and security of children’s personal information. Except for disclosure in accordance with laws and regulations and instructions from competent authorities, our company will not use or disclose minors’ personal privacy information to any third party.
			</div>
			<div class="txt_box">5. Information Security</div>
			<div class="txt_box pad-bot-15">
				We will take reasonable and practical electronic means and procedural safeguards to protect your personal information. Although data transmission over the Internet is not 100% secure, we have taken and will continue to take reasonable efforts in the commercial context to ensure that your personal information is protected.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesSix">Privacy</div>
			<div class="txt_box pad-bot-15">
				You may have certain rights and choices regarding our processing of your personal data. Depending on your jurisdiction, additional user authorizations may be granted to you, including the following rights (with certain limitations and exceptions):
				<ul>
					<li>Understand the categories and/or specific parts of the personal information collected about you, including whether your personal information has been sold or disclosed, and with whom your personal information is shared.</li>
					<li>Access a copy of the personal information we keep about you.</li>
					<li>Request to delete your personal information.</li>
				</ul>
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesSeven">Applicable Laws</div>
			<div class="txt_box pad-bot-15">
				By using this product, you agree that the laws of the United States and the State of California (without considering the principle of conflict of laws) will govern these conditions of use and any type of dispute that may arise between you and our company.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesEight">Amendments And Changes</div>
			<div class="txt_box pad-bot-15">
				In order to better provide our company's services, according to user needs, business rules and requirements of laws and regulations, our company reserves the right to add to, change, update, or modify this Privacy Policy at any time.  We will revise the relevant provisions of this guide in a timely manner.  Any such change, update, or modification will be effective immediately upon posting on this mobile application. It is your responsibility to review this Policy from time to time to ensure that you continue to agree with all of its terms.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesNight">Other Matters</div>
			<div class="txt_box pad-bot-15">
				The contents of this guide shall be implemented in accordance with this guide, and the matters not covered shall be executed in accordance with the relevant provisions of the "User Service Agreement" signed when you register and log in.
			</div>
			
			
			<div class="font-weight col-000 tit_two" id="quesTen">Contact Us</div>
			<div class="txt_box pad-bot-15">
				If you have any questions regarding this Privacy Policy, please contact us by sending an email to Peng@cordx.com.
			</div>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import goTop from '@/components/goTop';
export default {
	components:{
		'go-top': goTop
	},
	data() {
		return {
			//
		}
	},
	created(){
		this.$toast.loading({
			duration: 0,
		});
	},
	mounted() {
		this.$toast.clear();
	},
	watch: {
		//
	},
	methods: {
		//控制页面滚动
		jumpDom(value) {
			document.getElementById(value).scrollIntoView();
		}
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
*{color:#333333;}
</style>
